export const EXPENSE_TYPE_COLORS = {
  INVESTMENT: "cyan",
  UTILITY: "magenta",
  STAFF: "green",
  TAX: "red",
  COST: "blue",
  DEFAULT: "default",
} as const;

export const MODAL_CONFIGS = {
  NEW_DESCRIPTION: {
    title: "Add Description",
    content: "Are you sure you want to add new description?",
  },
  REACTIVATE_DESCRIPTION: {
    title: "Reactivate Description",
    content: "Are you sure you want to reactivate description?",
  },
  NEW_SUPPLIER: {
    title: "Add Supplier",
    content: "Are you sure you want to add new supplier?",
  },
  REACTIVATE_SUPPLIER: {
    title: "Reactivate Supplier",
    content: "Are you sure you want to reactivate supplier?",
  },
  NEW_DESCRIPTION_AND_SUPPLIER: {
    title: "Add Description and Supplier",
    content: "Are you sure you want to add new description and supplier?",
  },
  NEW_DESCRIPTION_AND_REACTIVATE_SUPPLIER: {
    title: "Add Description and Reactivate Supplier",
    content:
      "Are you sure you want to add new description and reactivate supplier?",
  },
  REACTIVATE_DESCRIPTION_AND_NEW_SUPPLIER: {
    title: "Reactivate Description and Add Supplier",
    content:
      "Are you sure you want to reactivate description and add supplier?",
  },
  REACTIVATE_DESCRIPTION_AND_SUPPLIER: {
    title: "Reactivate Description and Supplier",
    content: "Are you sure you want to reactivate description and supplier?",
  },
} as const;

export const PREFIX = {
  NEW: "new-",
  INACTIVE: "inactive-",
} as const;

export const SUFFIX = {
  NEW: " (NEW)",
  INACTIVE: " (INACTIVE)",
} as const;

export const RESPONSIVE_CONFIG = {
  xs: {
    span: 24,
    maxColumns: 1,
  },
  sm: {
    span: 12,
    maxColumns: 2,
  },
  md: {
    span: 8,
    maxColumns: 3,
  },
  lg: {
    span: 6,
    maxColumns: 4,
  },
} as const;
